import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

/* DTO basico para representar um estado de qualquer entidade no modelo */
export class Aviso extends BaseEntity {

	public tipo: number;
	public severidade: number;
	public dataCriacao: string;
	public loginUsuarioCriacao: String;
	public nomeUsuarioCriacao: String;
	public avisoAtivo: String;
	public agenteFinanceiroDestinatario: number;
	public dataDesativacao: string;
	public nomeUsuarioDesativacao: string;
	public nomeAnexo: string;
	public titulo: string;
	public mensagem: string;
	public horaDesativacao: {hour: number, minute: number, second: number}; // "transiente" para facilitar a desativação do aviso
}

export const TIPO_SEVERIDADE = [
	{
		codigo: 1,
		label: 'Urgente'
	},

	{
		codigo: 2,
		label: 'Informativo'
	}
];

export const TIPOS_AVISO = [
	{
		codigo: 1,
		label: 'Informe do Administrador'
	}
	,{
		codigo: 2,
		label: 'Previsão de pagamento de honras'
	}
	/* ,{
		codigo: 3,
		label: 'Valores de honra pagos' - Não existe para o PEAC
	} */
	,{
		codigo: 4,
		label: 'Aviso de confirmação'
	}
	,{
		codigo: 5,
		label: 'Valor Honrado a Recuperar'
	}
	,{
		codigo: 6,
		label: 'Amortização Antecipada Necessária'
	}
	,{
		codigo: 7,
		label: 'Valor de Exposição'
	}
  ];
